export default {
      id: "eye-slash-usage",
      viewBox: "0 0 26 18",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#eye-slash",
      toString: function () {
        return this.url;
      }
    }